import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import Icon from "../Common/Icon";
import Sharing from "./Sharing";
import scrollTo from "../../utils/scrollTo";
import ReactModal from "react-modal";
import Accessibility from "../Common/Accessibility";
import Prices from "./Prices";
import SharedIsi from "../../utils/sharedIsi";
import ToolTip from "../Common/ToolTip";
import { isMobile } from "react-device-detect";
import Api from "../../api/api";
import actions from "../../actions/dienstregeling";
export class TimeTable extends Component {
  timesPerRow = 12;
  static propTypes = {
    config: PropTypes.object,
  };

  constructor() {
    super();
    this.listRef = React.createRef();
    this.state = {
      showModal: false,
      stopName: null,
      stopTown: null,
      availablePdfStation: [],
    };
  }

  handleOpenModal = (stopTown, stopName) => {
    this.setState({ showModal: true, stopName, stopTown });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, stopName: null, stopTown: null });
  };
  componentDidUpdate(prevProps) {
    if (!this.listRef.current) return;

    const list = this.listRef.current;
    const { timetable = [], time, stops, route } = this.props.dienstregeling;
    let timeIndex = 0;
    if (timetable.length) {
      const formTime = parseInt(time.split(":").join(""), 10) * 100;
      const timeArray = timetable
        .map((trip) => trip.find((time) => time.departure))
        .map((time) => parseInt(time.departure.split(":").join(""), 10))
        .sort((a, b) => a - b);
      let closest = timeArray.reverse().find((e) => e <= formTime);
      if (closest) closest = closest.toString().padStart(6, "0");
      const timeEl = list.querySelector(`[data-timestamp="${closest}"]`);
      if (timeEl) {
        timeIndex = Array.from(timeEl.parentNode.children).indexOf(timeEl); // Index in table-row
        timeIndex--; //Remove Halte name
        const tables =
          timeEl.parentNode.parentNode.parentNode.parentNode.children;
        const timeTable = timeEl.parentNode.parentNode.parentNode;
        const tableIndex = Array.from(tables).indexOf(timeTable); //Index in list of tables
        timeIndex += tableIndex * this.timesPerRow;
        if (!timeIndex || typeof timeIndex !== "number") {
          timeIndex = 0;
        }
      }
    }

    if (this.props.dienstregeling !== undefined) {
      if (prevProps.dienstregeling !== this.props.dienstregeling) {
        var captions = SharedIsi.getCaptions(stops);
        this.props.setLoading(true);
        Api.getAvailablePdfByCaptions(
          captions,
          route.line_planning_number
        ).then((res) => {
          this.setState({ availablePdfStation: res.data });
          this.props.setLoading(false);
        });
      }
    }
    const items = this.getItemsOfList();
    scrollTo.scrollToIndex(list, items, timeIndex);
  }

  getAllItemsOfList() {
    return this.listRef.current.querySelectorAll(`.dienstregeling__trips-time`);
  }

  getItemsOfList() {
    return this.listRef.current.querySelectorAll(
      `.dienstregeling__trips-halte:first-child .dienstregeling__trips-time`
    );
  }

  formatTimetableTime(text) {
    const hours = text.substr(0, 2) % 24;
    const minutes = text.substr(3, 2);
    return moment(`${hours}:${minutes}`, "H:mm", true).format("HH:mm");
  }

  createStopLink = (stop, baseUrl = "/") => {
    const queryStringParam = {
      stopid: stop.stopId.replace(":Q:", ":S:"),
      town: stop.town || "?",
      name: stop.name || "?",
    };

    return `${baseUrl}?stop=${JSON.stringify(queryStringParam)}`;
  };

  hasNextDayDepartures(timetable) {
    let hasNextDayDeparturesFlag = false;
    const midnight = 24;
    timetable.map((tripRow) => {
      tripRow.map((trip) => {
        const timestamp = trip.departure ? trip.departure.split(":")[0] : "";
        if (timestamp >= midnight) {
          hasNextDayDeparturesFlag = true;
        }
      });
    });
    return hasNextDayDeparturesFlag;
  }

  renderPdfButton = (
    stop,
    dienstregeling,
    pdfNotExistMessage,
    pdfToolTipMessage,
    index
  ) => {
    if (!isMobile) {
      return (
        <ToolTip
          className="tooltip-message"
          content={pdfToolTipMessage}
          placement="right"
          isWhite={index % 2 !== 0 ? true : false}
        >
          <button
            className="btn--icon-only"
            onClick={() => {
              SharedIsi.downloadTravelInfoPdf(
                stop.quayCode,
                dienstregeling.route.line_planning_number,
                stop.town + "-" + stop.name,
                null,
                pdfNotExistMessage
              );
            }}
          >
            <Icon iconName="pdf" />
          </button>
        </ToolTip>
      );
    }
    return (
      <ToolTip
        className="tooltip-message"
        content={pdfToolTipMessage}
        placement="left"
        isWhite={index % 2 !== 0 ? true : false}
      >
        <button
          className="btn--icon-only"
          onClick={() => {
            SharedIsi.downloadTravelInfoPdf(
              stop.quayCode,
              dienstregeling.route.line_planning_number,
              stop.town + "-" + stop.name,
              null,
              pdfNotExistMessage
            );
          }}
        >
          <Icon iconName="pdf" />
        </button>
      </ToolTip>
    );
  };

  render() {
    const {
      dienstregeling,
      loading,
      config: {
        locale = "en-gb",
        sharing = {},
        noDepartureTimesTitleText = "This bus has no departure times at ",
        noDepartureTimesDescriptionText = "",
        dayTabHintText = "Change the date in the form above",
        soonerButtonText = "Sooner",
        soonerButtonHintText = "View sooner departure times",
        laterButtonText = "Later",
        laterButtonHintText = "View later departure times",
        stopsTitleText = "Information about stops",
        stopInformationText = "Information about stop",
        stopsTimesTitleText = "Timetable of stop departure times",
        departureTimesOfStop = "Departure times of stop",
        accessibleForText = "Accessible by",
        notAccessibleForText = "Not accessible by",
        wheelchairText = "wheelchairs",
        halteLinkBaseUrl,
        prices,
        downloadHeaderText = "Download Pdf",
        pdfToolTipMessage = "",
        pdfNotExist = "Pdf not exist",
        nextDayDisclaimer,
        nextDayDisclaimer2,
      },
    } = this.props;
    if (!dienstregeling) return null;

    let { stops = [], timetable = [], date } = dienstregeling;

    const hasDisturbances = stops
      ? stops.filter((stop) => stop.hasDisturbance).length > 0
      : false;
    const hasTimes = stops.length && timetable.length;

    moment.locale(locale);
    let dateTabText = moment(date, "DD-MM-YYYY").format("dddd D MMMM YYYY");
    dateTabText = dateTabText[0].toUpperCase() + dateTabText.substr(1);

    const { availablePdfStation } = this.state;
    return (
      <React.Fragment>
        {this.hasNextDayDepartures(timetable) && (
          <div className="container container--center dienstregeling__trips-next_day_text">
            <span className="dienstregeling__trips-time--next_day">
              {nextDayDisclaimer}
            </span>
            {" " + nextDayDisclaimer2}
          </div>
        )}
        <div
          className={`
          dienstregeling__navigation
          ${loading && "dienstregeling__navigation--loading"}
        `}
        >
          <div className="container container--center dienstregeling__navigation-center">
            <div className="dienstregeling__tab-first">
              <div className="tabs">
                <div className="tabs__scroller js-tabs-scroller">
                  <ul className="tabs__list">
                    <li className="tabs__item">
                      <button
                        className="tabs__btn is-selected"
                        title={dayTabHintText}
                      >
                        {dateTabText}
                      </button>
                      <div className="tabs__indicator" />
                    </li>
                  </ul>
                </div>
              </div>
              {availablePdfStation.length > 0 && (
                <div className="dienstregeling__pdf">{downloadHeaderText}</div>
              )}
            </div>
            {!hasTimes ? null : (
              <div className="dienstregeling__navigation-buttons">
                <button
                  className="dienstregeling__navigation-button btn"
                  onClick={this.handlePrevPage}
                  title={soonerButtonHintText}
                >
                  <Icon
                    className="dienstregeling__navigation-icon btn__icon btn__icon--left"
                    iconName="arrow-left"
                  />
                  {soonerButtonText}
                </button>
                <button
                  className="dienstregeling__navigation-button btn"
                  onClick={this.handleNextPage}
                  title={laterButtonHintText}
                >
                  {laterButtonText}
                  <Icon
                    className="dienstregeling__navigation-icon btn__icon btn__icon--right"
                    iconName="arrow-right"
                  />
                </button>
              </div>
            )}
          </div>
        </div>

        <div
          className={`
            dienstregeling__haltes
            ${loading ? "dienstregeling__haltes--loading" : ""}
            ${hasDisturbances ? "dienstregeling__haltes--has-disturbances" : ""}
          `}
        >
          {!hasTimes ? (
            <div className="container container--clearfix container--accent1-tint5">
              <div className="container container--center container--margin">
                <h3>
                  {noDepartureTimesTitleText} {dateTabText}
                </h3>
                <p>{noDepartureTimesDescriptionText}</p>
              </div>
            </div>
          ) : (
            <div className="container container--center dienstregeling__haltes-container">
              <h3 className="sr-only">{stopsTitleText}</h3>
              <ul className="dienstregeling__haltes-info-list">
                {stops.map((stop, i) => {
                  const hasDisruption = !!timetable.filter(
                    (trip) => trip[i].trip_schedule === "SKIPPED"
                  ).length;
                  const hasDepartures = !!timetable.filter(
                    (trip) => trip[i].departure
                  ).length;
                  const stopName =
                    !stop.town && !stop.name
                      ? "Haltenaam onbekend"
                      : `${stop.town}, ${stop.name}`;
                  return (
                    <li
                      className="dienstregeling__halte"
                      key={`${i}${stop.town}${stop.name}`}
                    >
                      <div className="dienstregeling__halte-info">
                        <div className="dienstregeling__halte-icons">
                          <div className="sr-only">
                            {stopInformationText}: {stop.name}{" "}
                          </div>
                          <div className="dienstregeling__halte-icon" />
                          {hasDisruption || !hasDepartures ? (
                            <Icon
                              className="dienstregeling__halte-storing-icon"
                              iconName="storingen"
                            />
                          ) : null}
                        </div>
                        <div className="dienstregeling__halte-name">
                          {stop.stopId && halteLinkBaseUrl ? (
                            <a
                              className="dienstregeling__halte-name-link"
                              href={this.createStopLink(stop, halteLinkBaseUrl)}
                              title={stopName}
                            >
                              {stopName}
                            </a>
                          ) : (
                            stopName
                          )}
                        </div>
                        <div
                          className={`${
                            availablePdfStation.length > 0 &&
                            (!stop.quayCode ||
                              !availablePdfStation.find(
                                (caption) =>
                                  caption === stop.quayCode.split(":")[2]
                              ))
                              ? "dienstregeling__halte-accessibility-margin"
                              : ""
                          } dienstregeling__halte-accessibility`}
                        >
                          <div
                            className={`${
                              !stop.disabledAccessible
                                ? "dienstregeling__not-icon"
                                : ""
                            }`}
                          >
                            <span className="sr-only" tabIndex="0">
                              {stop.disabledAccessible
                                ? accessibleForText
                                : notAccessibleForText}
                            </span>
                            <Icon
                              iconName="wheelchair"
                              title={
                                stop.disabledAccessible
                                  ? accessibleForText
                                  : notAccessibleForText
                              }
                            />
                          </div>
                        </div>
                        <div className="dienstregeling__halte-pdf">
                          {availablePdfStation.length > 0 &&
                            stop.quayCode &&
                            availablePdfStation.find(
                              (caption) => caption === stop.quayCode.split(":")[2]
                            ) &&
                            this.renderPdfButton(
                              stop,
                              dienstregeling,
                              pdfNotExist,
                              pdfToolTipMessage,
                              i
                            )}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
              <div className="dienstregeling__trips-container">
                <h3 className="sr-only">{stopsTimesTitleText}</h3>
                <ul className="dienstregeling__trips-tables" ref={this.listRef}>
                  {timetable.map((trip, tripIndex) => {
                    //Show trips in tables of (12) rows for the print view
                    if (tripIndex % this.timesPerRow !== 0) return null;

                    const trips = timetable.slice(
                      tripIndex,
                      Math.min(tripIndex + this.timesPerRow, timetable.length)
                    );
                    return (
                      <li
                        className="dienstregeling__trips-table"
                        key={`trip-table-${tripIndex}`}
                      >
                        <div className="dienstregeling__trips-head">
                          <ul className="dienstregeling__trips-head-row">
                            <li className="dienstregeling__trips-head-cell">
                              {stopsTimesTitleText}
                            </li>
                            <li className="dienstregeling__trips-head-cell"></li>
                          </ul>
                        </div>
                        <div className="dienstregeling__trips-table-body">
                          {stops.map((stop, stopIndex) => {
                            return (
                              <ul
                                className="dienstregeling__trips-halte"
                                key={`${stopIndex}${stop.town}${stop.name}`}
                              >
                                <div className="dienstregeling__trips-halte-info">
                                  <div className="dienstregeling__trips-halte-name">
                                    <div className="sr-only">
                                      {departureTimesOfStop}
                                    </div>
                                    {stop.town}, {stop.name}
                                  </div>
                                  <div className="dienstregeling__trips-halte-accessibility">
                                    <div
                                      className={`${
                                        !stop.disabledAccessible
                                          ? "dienstregeling__not-icon"
                                          : ""
                                      }`}
                                    >
                                      <Icon
                                        iconName="wheelchair"
                                        title={wheelchairText}
                                      />
                                    </div>
                                  </div>
                                </div>
                                {trips.map((trip, i) => {
                                  const time = trip[stopIndex] || {};
                                  const midnight = 240000;
                                  const timestamp = time.departure
                                    ? time.departure.split(":").join("")
                                    : "";
                                  const formattedTime = time.departure
                                    ? this.formatTimetableTime(time.departure)
                                    : null;
                                  const realTime =
                                    time.realtime_departure_time || 0;
                                  return (
                                    <li
                                      className="dienstregeling__trips-time"
                                      key={`${i}-${tripIndex}-${time.departure}`}
                                      data-timestamp={timestamp}
                                    >
                                      {time.trip_schedule === "SKIPPED" ? (
                                        <span className="dienstregeling__time-block--cancelled">
                                          {formattedTime}
                                        </span>
                                      ) : (
                                        formattedTime
                                      )}
                                      {timestamp >= midnight && (
                                        <span className="dienstregeling__trips-time--next_day">
                                          *
                                        </span>
                                      )}
                                      {realTime <= 0 ? null : (
                                        <span className="dienstregeling__delayed-time">
                                          + {realTime} min
                                        </span>
                                      )}
                                    </li>
                                  );
                                })}
                              </ul>
                            );
                          })}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}
        </div>
        <div className="container container--center">
          <Sharing config={sharing} />
        </div>
        <ReactModal
          isOpen={this.state.showModal}
          style={{ overlay: {}, content: {} }}
          overlayClassName="modal__overlay"
          bodyOpenClassName="modal--open"
          shouldFocusAfterRender={false}
          className="modal"
        >
          <button onClick={this.handleCloseModal} className="modal__close-btn">
            ✖
          </button>
          <div className="modal__content">
            <h2>
              Halte: {this.state.stopTown}, {this.state.stopName}
            </h2>
            {/* @TODO: Dit moet nog dynamisch gemaakt worden */}
            <Accessibility
              types={[
                "blind-yes",
                "blind-no",
                "wheelchair-yes",
                "wheelchair-no",
              ]}
            />
            <button>
              Halte-informatie{" "}
              <Icon
                className="btn__icon btn__icon--right"
                iconName="arrow-right"
              />
            </button>
          </div>
        </ReactModal>
        <Prices dienstregeling={dienstregeling} prices={prices} />
      </React.Fragment>
    );
  }

  handlePrevPage = () => {
    if (!this.listRef.current) return;
    const allItems = this.getAllItemsOfList();
    const items = this.getItemsOfList();
    scrollTo.scrollByPages(this.listRef.current, items, -1, allItems);
  };

  handleNextPage = () => {
    if (!this.listRef.current) return;
    const allItems = this.getAllItemsOfList();
    const items = this.getItemsOfList();
    scrollTo.scrollByPages(this.listRef.current, items, 1, allItems);
  };
}

export default connect(
  (state) => {
    return state.dienstregeling;
  },
  (dispatch) => {
    return {
      setLoading: (loading) => dispatch(actions.setLoading(loading)),
    };
  }
)(TimeTable);



// WEBPACK FOOTER //
// ./src/components/Dienstregeling/TimeTable.js